import { axiosInstance } from './axios-instance';
import { PAGE_SIZE } from '../magic-values';
import type { PaginationDto } from '../types/common';
import type { JobTask, ListJobTasksResponse } from '../types/job-task';

export interface JobTasksFilters {
  accountId: string;
  jobId?: string;
  filterBy?: string;
  status?: string;
  type?: string;
}

export class JobTaskService {
  static async getJobTasks(
    filters: JobTasksFilters,
    pagination?: PaginationDto,
  ): Promise<ListJobTasksResponse> {
    const res = await axiosInstance.get<ListJobTasksResponse>('/admin/job-tasks', {
      params: { pageSize: PAGE_SIZE, ...pagination, ...filters },
    });
    return res.data;
  }

  static async getJobTask(id: string, accountId: string): Promise<JobTask> {
    const res = await axiosInstance.get<JobTask>(`/admin/job-tasks/${id}`, {
      params: { accountId },
    });
    return res.data;
  }
}
